import { z } from "zod";
export const PAYMENT_TYPES = ["deposit", "remainder", "security"];
export const paymentTypeSchema = z.enum(PAYMENT_TYPES);
export const PaymentTypeEnum = {
    DEPOSIT: "deposit",
    REMAINDER: "remainder",
    SECURITY: "security",
};
